import { DetailsWithCard } from '../DetailsWithInfoColumn/DetailsWithInfoColumn';
import { BillingAccountAndUserInfoDetails } from './Components/BillingAccountAndUserInfoDetails.js';
import { CardContent } from './Components/CardContent';
import type { BillChannel } from '../../generated/api/billChannel';
import type { BillingAccountsResponse } from '../../generated/api/billingAccountsResponse';
import type { CompanyInfoResponse } from '../../generated/api/companyInfoResponse';
import type { Contact } from '../../generated/api/contact';
import type { GetSubscriptionScheduledChanges } from '../../generated/api/getSubscriptionScheduledChanges.js';
import type { Subscription } from '../../generated/api/subscription';
import type { ReactNode } from 'react';

interface SubscriptionBillingAccountContractProps {
  subscription: Subscription;
  companyInfo: CompanyInfoResponse;
  billingAccounts: BillingAccountsResponse;
  contacts: Contact[];
  hasPendingActions: boolean;
  disclaimerContent?: ReactNode;
  billChannels: BillChannel[];
  subscriptionScheduledChanges?: GetSubscriptionScheduledChanges;
}

export const SubscriptionBillingAccountUserInformation = ({
  subscription,
  companyInfo,
  billingAccounts,
  contacts,
  hasPendingActions,
  disclaimerContent,
  billChannels,
  subscriptionScheduledChanges,
}: SubscriptionBillingAccountContractProps) => (
  <DetailsWithCard cardContent={<CardContent subscription={subscription} />} disclaimerContent={disclaimerContent}>
    <BillingAccountAndUserInfoDetails
      subscription={subscription}
      companyInfo={companyInfo}
      billingAccounts={billingAccounts}
      contacts={contacts}
      hasPendingActions={hasPendingActions}
      billChannels={billChannels}
      subscriptionScheduledChanges={subscriptionScheduledChanges}
    />
  </DetailsWithCard>
);
